import React, { useState, useEffect } from 'react';
import InputWrapper from '../InputWrapper';
import marked from 'marked';
import sanitizeHtml from 'sanitize-html';
import { withTranslation } from 'react-i18next';
import { Divider, Icon, Message } from 'semantic-ui-react';
import anchorme from 'anchorme';

import InputWithLabelWrapper from '../InputWithLabelWrapper';
import PropTypes from 'prop-types';

const MarkDownEditorComponent = props => {
  const [edit, setEdit] = useState(props.edit);
  const [html, setHtml] = useState();
	const {label, setFieldValue, ...reducedProps} = props;

  const updateHtml = () => {
    const tokens = marked.lexer(createLinks(props.values[props.name]));
    setHtml(marked.parser(tokens, { sanitizer: sanitizeHtml }));
  };

  const createLinks = value => {
    return value
      ? anchorme(props.values[props.name], {
          attributes: [
            {
              name: 'target',
              value: '_blank'
            }
          ]
        }).replace(/\n/g, '</br>')
      : '';
  };

  useEffect(() => {
    updateHtml();
  }, [edit]);

  const getEditor = () => {
    return edit ? getEditModeInput() : getViewModeInput();
  };

  const getViewModeInput = () => {
    let htmlDiv = <div id="markDownViewMode" dangerouslySetInnerHTML={{ __html: html }} />;
    return props.displayAsInfo && html ? <Message info>{htmlDiv}</Message> : htmlDiv;
  };

  const getEditModeInput = () => {
    return (
      <>
        {props.warning && <Message color="yellow">{props.t(props.warning)}</Message>}
        <InputWrapper
          {...props}
          type="textArea"
          rows={props.rows}
          value={props.values[props.name] ? props.values[props.name].replace(/<\/br>/g, '\n') : ''}
        />
      </>
    );
  };

  return (
    <>
      {props.canEdit && (
        <>
          <span className="markdown">
            <InputWithLabelWrapper
              {...reducedProps}
              value={edit}
              name="edit"
              label={props.label}
              fieldClassName="inline checkboxMargin"
              width={16}
              render={() => (
                <>
                  {' '}
                  <Icon name="edit" />
                  <InputWrapper
										{...reducedProps}
										type="checkbox"
                    name="edit"
                    toggle
                    onChange={() => setEdit(!edit)}
                  />
                </>
              )}
            />
          </span>
          <Divider />
        </>
      )}
      {getEditor()}
    </>
  );
};

MarkDownEditorComponent.propTypes = {
  values: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  edit: PropTypes.bool,
  rows: PropTypes.number,
  displayAsInfo: PropTypes.bool,
  canEdit: PropTypes.bool,
  warning: PropTypes.string
};

MarkDownEditorComponent.defaultProps = {
  edit: false,
  label: 'markdown.edit',
  displayAsInfo: false,
  rows: 20,
  canEdit: true
};

export default withTranslation()(MarkDownEditorComponent);
